import * as THREE from 'three';
import React, { useMemo } from 'react'
import { const_var, params } from '../../../../redux/reducers/reducer';
import { logoTexture } from '../../../../redux/reducers/utils';

const Watermark = () => {

    useMemo(()=>{
        logoTexture();
    },[const_var.scene,params.p_w,params.p_h,params.p_d,params.p_f_w,params.p_b_w,params.p_u_c,params.p_u_t])

    return (
        <>
            <mesh name="manufacturerLogoFront" visible={false}>
                <planeGeometry args={[1, 1,400,400]}  />
                <meshPhongMaterial side={THREE.DoubleSide} needsUpdate={true} shininess={1} />
            </mesh>
            
            <mesh name="manufacturerLogoBack" visible={false}>
                <planeGeometry args={[1, 1,400,400]} />
                <meshPhongMaterial side={THREE.DoubleSide} needsUpdate={true} shininess={1}/>
            </mesh>
            
            <mesh name="manufacturerLogoCenter" visible={false}>
                <planeGeometry args={[1, 1,400,400]} />
                <meshPhongMaterial side={THREE.DoubleSide} needsUpdate={true} shininess={1}/>
            </mesh>
    
            
        </>
    )
}

export default Watermark